import { EActivityType } from '@constants';
import { IActivity } from '@sdk/contracts';

import { InfoWrapper, ResourceWrapper, Wrapper } from './TaskPreview.styles';

import { PdfPreview } from '@/components/ActivityPreview/PdfPreview';
import { VideoPlayer } from '@/components/VideoPlayer';

type Props = {
  activity?: IActivity;
};

export const TaskPreview: React.FC<Props> = ({ activity }) => {
  if (!activity) return null;
  const { type, task } = activity;
  if (!task || !task.resource) return null;

  return (
    <Wrapper>
      <InfoWrapper>
        <div>{task.title}</div>
        <div>{task.description}</div>
      </InfoWrapper>
      <ResourceWrapper>
        {type === EActivityType.VIDEO && <VideoPlayer file={task.resource.file} />}
        {type === EActivityType.PDF && <PdfPreview file={task.resource.file} />}
        {type === EActivityType.DELIVERABLE && <PdfPreview file={task.resource.file} />}
      </ResourceWrapper>
    </Wrapper>
  );
};
